export const AmplitudeRequiredCookieConsentGroup = 'C0002' // Performance Cookies
